// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"968":"776b0b68","5296":"88160a2e","7257":"c14735cd","9453":"5726eb55"}[chunkId] + ".chunk.css";
};